module.exports = __webpack_public_path__ + "static/media/3-apm.04fa177b.svg";